export default "__VITE_ASSET__wja5$dkt__"